package com.essntl.features.supplier.domain.model

import com.essntl.features.area.domain.model.AreaModel
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.contact.domain.model.ContactModel

data class SupplierModel(
    val id: String,
    val currency: String?,
    val description: String?,
    val contactName: String?,
    val area: AreaModel?,
    val category: CategoryModel?,
    val contact: ContactModel?,
    val createdAt: String,
) {
    val prettyName
        get() = contact?.organization?.name.orEmpty()

    /**
     * Returns a new instance of the SupplierModel with only the fields that have changed from the given supplierModel.
     *
     * @param supplierModel The SupplierModel to compare with.
     * @return A new instance of SupplierModel with only the changed fields.
     */
    fun getChangedFields(supplierModel: SupplierModel) =
        SupplierModel(
            id = id,
            createdAt = createdAt,
            currency = if (currency.orEmpty() != supplierModel.currency.orEmpty()) supplierModel.currency else null,
            description = if (description.orEmpty() != supplierModel.description.orEmpty()) supplierModel.description else null,
            contactName = if (contactName.orEmpty() != supplierModel.contactName.orEmpty()) supplierModel.contactName else null,
            area = if (area?.id != supplierModel.area?.id) supplierModel.area else null,
            category = if (category?.id != supplierModel.category?.id) supplierModel.category else null,
            contact = if (contact?.id != supplierModel.contact?.id) supplierModel.contact else null,
        )

    val isEmpty get() = this.copy(id = "", createdAt = "") == empty

    companion object {
        val empty =
            SupplierModel(
                id = "",
                createdAt = "",
                currency = null,
                description = null,
                contactName = null,
                area = null,
                category = null,
                contact = null,
            )
    }
}